define('modules/auth/modals/modals.controller',[
    "client"
], function(
    Prospector)
{
    Prospector.module("ModalApp.Auth", function(Auth, Prospector, Backbone, Marionette, $, _){
        Auth.Controller = {
            showCompatability: function() {
                require(["modules/auth/modals/views/not.supported.view"], function(NotSupportedView){
                    var ecv = new NotSupportedView();
                    Prospector.trigger('showModal', {view: ecv});
                });
            }
        }
    });
    return Prospector.ModalApp.Auth.Controller;
});
